/**
* Treatment Details JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatment Details component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'treatment-details',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.treatment-details' ).length > 0 ) {
        $( '.treatment-details__content' ).each( function( index, element ) {
          const mm = gsap.matchMedia();
          mm.add( '(min-width: 1024px)', () => {
            ScrollTrigger.create( {
              trigger: this,
              pin: true,
              pinSpacing: false,
              start: '50% 50%',
              end: '+=' + ( $( this ).closest( '.treatment-details__content-wrapper' ).outerHeight() - $( this ).outerHeight() ),
              scrub: 0,
            } );
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'treatment-details', COMPONENT );
} )( app );
